// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__3hgHR","header":"MessagesList_header__bbWVT","chat":"MessagesList_chat__2lL2v"};